// extracted by mini-css-extract-plugin
export default {"userSelect":"SelectUserTypePage_userSelect__bWnC2","userTypeContainer":"SelectUserTypePage_userTypeContainer__XCMvK","userType":"SelectUserTypePage_userType__Qai2Y"};